import request from '@/utils/request'

// 刷新 token
export function refreshToken (data) {
  return request({
    url: '/v1/user/refreshToken',
    method: 'post',
    data: {
      ...data,
      device: 'PC'
    },
    skipTokenRefresh: true // 标记此请求不需要 token 刷新拦截
  })
}

// 获取当前我发布的同校
export function getMySayList (params) {
  return request({
    url: '/v1/say/getMySayList',
    method: 'get',
    params: params
  })
}

/**
 * 获取关注列表。
 *
 * @param {Object} params - { pageNo, pageSize, userId }
 *   userId 不传表示看自己的，传了表示看指定用户的。
 *
 * 看别人的列表要过对方的「关注列表可见范围」隐私设置。被挡下时服务端返回的是
 * 200 + 空页 + extra.listVisible = false，<b>不是错误</b> —— 调用方必须读
 * extra.listVisible 才能把「TA 隐藏了关注列表」和「TA 一个人都没关注」区分开。
 *
 * 列表里每个人的 followStatus / hasFollower 都是相对<b>登录人</b>算的，
 * 不是相对被查看的人。
 */
export function getMyFollowedList (params) {
  return request({
    url: '/v1/followed/selectMyFollowed',
    method: 'get',
    params
  })
}

/**
 * 获取粉丝列表。语义与 getMyFollowedList 完全对称，
 * 隐私闸读的是对方的「粉丝列表可见范围」。
 *
 * @param {Object} params - { pageNo, pageSize, userId }
 */
export function getMyFansList (params) {
  return request({
    url: '/v1/followed/selectMyFans',
    method: 'get',
    params
  })
}

/**
 * 获取互相关注列表。语义与 getMyFollowedList 对称，
 * 看别人时隐私闸跟对方的「关注列表可见范围」走。
 *
 * @param {Object} params - { pageNo, pageSize, userId }
 */
export function getMyMutualList (params) {
  return request({
    url: '/v1/followed/selectMyMutual',
    method: 'get',
    params
  })
}

/**
 * 我关注的人（分享选人面板用）：最近关注的在最前，已拉黑的不在列表里。
 * 只回头像昵称，不回填关注三态。
 *
 * @param {Object} params - { pageNo, pageSize }
 */
export function getMyFriends (params) {
  return request({
    url: '/v1/followed/selectMyFriends',
    method: 'get',
    params
  })
}

/**
 * 按昵称 / 平台账号搜索我关注的人（分享选人面板的搜索框）。
 *
 * @param {Object} params - { keyword, pageNo, pageSize }
 */
export function searchMyFollowed (params) {
  return request({
    url: '/v1/followed/searchMyFollowed',
    method: 'get',
    params
  })
}

/**
 * 推荐关注用户。只给登录人自己用，不接受 userId。
 *
 * @param {Object} params - { pageNo, pageSize }
 */
export function getRecommendUsers (params) {
  return request({
    url: '/v1/user/recommend',
    method: 'get',
    params
  })
}

// 获取评论区 @ 候选人。
// keyword 为空时返回「我经常@的人 + 我关注的人」，非空时全站搜人（不限于好友）。
// 接口不分页，一次返回 20 个以内。
//
// 为什么不用 /v1/user/search 做搜索：它会往返回的昵称里注入高亮标记（插进评论正文就是乱码），
// 还会把关键词写进用户的搜索历史，@ 一下人就污染一条搜索记录。
// 也不用 /v1/followed/* ：那些接口给不了「我经常@的人」，而且只能搜到自己关注的人。
export function getAtCandidates (params) {
  return request({
    url: '/v1/comment/atCandidates',
    method: 'get',
    params
  })
}
// 查看我的点赞
export function getMyLikeList (params) {
  return request({
    url: '/v1/user/getMyLike',
    method: 'get',
    params
  })
}
// 获取我的评论
export function getMyCommentList (params) {
  return request({
    url: '/v1/comment/getMyComment',
    method: 'get',
    params
  })
}
// 设置帖子仅自己可见
export function setArticlePrivate (data) {
  return request({
    url: '/v1/post/',
    method: 'put',
    data
  })
}
export function getCollect (params) {
  return request({
    url: `/v1/collect/`,
    method: 'get',
    params: params
  }
  )
}
// 收藏
export function postCollect (params) {
  return request({
    url: '/v1/collect/collect',
    method: 'get',
    params
  })
}
// 取消收藏
export function cancelCollect (params) {
  return request({
    url: '/v1/collect/cancel',
    method: 'get',
    params
  })
}
export function featchComments (params) {
  return request({
    url: '/v1/comment/',
    method: 'get',
    params: params
  })
}

// 获取父评论列表
export function fetchParentComments (params) {
  return request({
    url: '/v1/comment/parentList',
    method: 'get',
    params: params
  })
}

// 获取子评论列表
export function fetchChildComments (params) {
  return request({
    url: '/v1/comment/childList',
    method: 'get',
    params: params
  })
}

// 定位评论所在楼层（「锚点楼」）。
//
// 从消息中心 / 个人中心「我的评论」点进详情时，手上只有一个 commentId，
// 而它很可能是条回复 —— 回复要等用户点「展开N条回复」才会渲染，
// 此前拿着子评论 id 去查 ref 必然查不到，定位就是空转。
// 这个接口让服务端一次把「目标所在的整楼」算好（父评论 + 目标回复所在那一页回复），
// 前端置顶插到评论列表最前面并默认展开，定位由碰运气变成一次必中。
//
// params: { articleId, commentId }
// 返回 data: { found, reason, message, targetId, child, rootId, parentComment,
//              childRecords, childPageNo, childPageSize, childTotal,
//              childHasMore, childHasPrevious }
// found=false 时按普通方式加载评论区，并用 message 提示用户（评论已删除/审核中等）。
export function locateComment (params) {
  return request({
    url: '/v1/comment/locate',
    method: 'get',
    params: params
  })
}

export function newArticle () {
  return request({
    url: '/v1/upToDateArticle',
    method: 'get',
  })
}

export function postComment (data) {
  return request({
    url: '/v1/comment/',
    method: 'post',
    data
  })
}
export function getSignRecords (params) {
  return request({
    url: '/v1/sign/getSignRecords',
    method: 'get',
    params: params
  })
}
export function validateTodayIsSign () {
  return request({
    url: '/v1/sign/validateTodayIsSign',
    method: 'get',
  })
}
export function sign (time) {
  return request({
    url: '/v1/sign/',
    method: 'get',
    params: {
      time: time
    }
  })
}

export function readMarkdownFile (data) {
  return request({
    url: '/v1/post/readMarkdownFile',
    method: 'post',
    data
  })
}
export function insertArticle (data) {
  return request({
    url: '/v1/post/insertArticle',
    method: 'post',
    data
  })
}
// export function updateArticle (data) {
//   return request({
//     url: '/v1/post/updateMyArticle',
//     method: 'post',
//     data
//   })
// }
export function searchArticle (params) {
  return request({
    url: '/v1/post/search',
    method: 'get',
    params: params
  })
}

// export function getCollect () {
//   return request({
//       url: '/v1/collect/',
//       method: 'get'
//   })
// }
// export function collect (id) {
//   return request({
//       url: '/v1/collect/collect',
//       method: 'get',
//       params: {
//           articleId: id
//       }
//   })
// }
// export function cancelCollect (id) {
//   return request({
//       url: '/v1/collect/',
//       method: 'delete',
//       params: {
//           articleId: id
//       }
//   })
// }

/**
 * 关注用户
 *
 * 注意返回值：对方是私密账号时不会直接建立关注关系，而是提交一条待审核的申请，
 * 此时 code 依然是 200，但 data.followStatus === 2（FOLLOW_STATUS.PENDING）、
 * data.pending === true。调用方不能只判 code 就把按钮切成「已关注」，
 * 应按 data.followStatus 渲染，参考 src/constant/followStatus.js。
 *
 * @param {Object} data - { userId }
 */
export function followedUser (data) {
  return request({
    url: '/v1/followed/insertFollowed',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 取消关注 / 撤回关注申请
 *
 * 两种场景共用一个接口：服务端按记录当前状态决定要不要回退粉丝数，
 * 待审申请从未计入过计数，撤回时不会动任何数字。
 */
export function deleteFollowedUser (userId) {
  return request({
    url: '/v1/followed/deleteFollowed',
    method: 'delete',
    params: {
      userId: userId
    }
  })
}

/**
 * 移除粉丝：断开「对方关注我」，不影响我是否关注对方。
 * 对方不会收到通知，之后仍可再次关注。
 *
 * @param {String|Number} userId 粉丝的用户 id
 */
export function removeFanUser (userId) {
  return request({
    url: '/v1/followed/removeFan',
    method: 'delete',
    params: {
      userId: userId
    }
  })
}

/**
 * 同意关注申请。通过之后关注关系才真正生效并计入粉丝数。
 *
 * 申请列表没有独立接口：它合并进了「收到的关注」通知列表
 * （messageFetch.getMessageNotice({ type: 2 }) 会同时返回 noticeType 2 和 7），
 * 见 src/view/notice/index.vue。
 *
 * @param {String} userId 申请人 id
 */
export function approveFollowRequest (userId) {
  return request({
    url: '/v1/followed/approveFollowRequest',
    method: 'post',
    params: {
      userId: userId
    }
  })
}

/**
 * 拒绝关注申请。服务端直接删除申请记录，对方之后仍可再次申请（与抖音一致）
 *
 * @param {String} userId 申请人 id
 */
export function rejectFollowRequest (userId) {
  return request({
    url: '/v1/followed/rejectFollowRequest',
    method: 'post',
    params: {
      userId: userId
    }
  })
}
export function addFeedback (data) {
  return request({
    url: '/v1/feedback/insertFeedback',
    method: 'post',
    data
  })
}

// 点赞评论
export function likeComment (commentId) {
  return request({
    url: '/v1/comment/commentLike',
    method: 'get',
    params: {
      commentId: commentId
    }
  })
}
// 删除评论。评论作者可删自己的评论；帖子作者可删自己帖子下任何人的评论（服务端校验）
export function deleteComment (commentId) {
  return request({
    url: '/v1/comment/deleteComment',
    method: 'get',
    params: {
      commentId: commentId
    }
  })
}

/**
 * 举报评论（评论「···」菜单里的举报）
 *
 * 与举报帖子 /v1/post/report 是两个独立接口，举报原因共用同一套枚举。
 *
 * @param {Object} data
 * @param {String} data.commentId   被举报的评论 id（雪花 id，按字符串传）
 * @param {Number} data.reportType  举报原因 code
 * @param {String} [data.description] 补充说明，最多 500 字
 * @param {Array<String>} [data.images] 举报材料图片链接，最多 3 张
 */
export function reportComment (data) {
  return request({
    url: '/v1/comment/report',
    method: 'post',
    data
  })
}

/**
 * 获取举报评论的原因列表
 * @returns {Promise} data 为 [{ code, desc }]
 */
export function getCommentReportTypes () {
  return request({
    url: '/v1/comment/reportTypes',
    method: 'get'
  })
}

// 获取搜索历史记录
export function getSearchHistory () {
  return request({
    url: '/v1/post/selectMySearchHistory',
    method: 'get'
  })
}

// 删除搜索历史记录
export function deleteSearchHistory (data) {
  return request({
    url: '/v1/post/deleteMySearchHistory',
    method: 'post',
    data
  })
}

// 获取用户昵称列表
export function getNickNameList () {
  return request({
    url: '/v1/user/getNickNameList',
    method: 'get'
  })
}

// 搜索用户
export function searchUser (params) {
  return request({
    url: '/v1/user/search',
    method: 'get',
    params
  })
}

/**
 * 举报用户（他人主页三点菜单里的举报入口）
 *
 * 与举报帖子 /v1/post/report 是两个独立接口，举报原因共用同一套枚举
 * （所以 reportTypes 两边返回的列表目前是一样的，但走各自的接口，方便后续分开演进）。
 *
 * @param {Object} data
 * @param {String|Number} data.reportedUserId 被举报的用户 id
 * @param {Number} data.reportType   举报原因 code（1-17）
 * @param {String} [data.description] 补充说明，最多 500 字
 * @param {Array<String>} [data.images] 举报材料图片链接，最多 3 张
 */
export function reportUser (data) {
  return request({
    url: '/v1/user/report',
    method: 'post',
    data
  })
}

/**
 * 获取举报用户的原因列表
 * @returns {Promise} data 为 [{ code, desc }]
 */
export function getUserReportTypes () {
  return request({
    url: '/v1/user/reportTypes',
    method: 'get'
  })
}

/**
 * 生成用户主页的分享口令文本（含网页版主页链接）
 *
 * 文案由服务端拼（昵称、互动数据、口令码、日期、站点域名都在那边一处维护），
 * 前端不要自己拼，否则「复制链接」和其它渠道分享出去的文案会不一致。
 *
 * @param {String|Number} userId 被分享的用户 id
 * @returns {Promise} data 为一段可直接写进剪贴板的字符串
 */
export function getUserShareText (userId) {
  return request({
    url: '/v1/user/shareText',
    method: 'get',
    params: { userId }
  })
}
